const ServiceRefreshment = (state) => state.ServiceRefreshment

export default {
  ServiceRefreshment
}
